import lookup from './lookup.store'
import jasperReport from './jasper-report.store'
import department from './department.store'
import departmentResponsible from './department-responsible.store'
import labExt from './lab-ext.store'
import labExtTopic from './lab-ext-topic.store'
import attachment from './attachment.store'
import province from './province.store'
import amphur from './amphur.store'
import tambon from './tambon.store'
import address from './address.store'
import country from './country.store'
import product from './product.store'
import labCompany from './lab-company.store'
import city from './city.store'
import labTopic from './lab-topic.store'
import labTopicMethod from './lab-topic-method.store'
import labCountryStandardGroup from './lab-country-standard-group.store'
import labCountryStandardGroupRel from './lab-country-standard-group-rel.store'
import labCountryStandardGroupMapper from './lab-country-standard-group-rel.store'
import labProductGroup from "./lab-product-group.store";
import labProductGroupRel from "./lab-product-group-rel.store";
import samplingMonitorType from "./sampling-monitor-type.store";
import samplingMonitorSpecies from "./sampling-monitor-species.store";
import samplingMonitorTypeLabTopic from "./sampling-monitor-type-lab-topic.store";
import labCountryStandardGroupTopic from './lab-country-standard-group-topic.store'
import labCountryStandardGroupTopicLabTopic from './lab-country-standard-group-topic-lab-topic.store'
import samplingMonitorProduct from './sampling-monitor-product.store'
import labMonitorProductGroup from './lab-monitor-product-group.store'
import labMonitorProductGroupRel from './lab-monitor-product-group-rel.store'
import labMonitorProductGroupTopic from './lab-monitor-product-group-topic.store'

export default {
    lookup,
    jasperReport,
    department,
    departmentResponsible,
    attachment,
    city,
    province,
    amphur,
    tambon,
    address,
    country,
    product,
    labCompany,
    labTopic,
    labTopicMethod,
    labCountryStandardGroup,
    labCountryStandardGroupRel,
    labCountryStandardGroupMapper,
    labExt,
    labExtTopic,
    labProductGroup,
    labProductGroupRel,
    samplingMonitorType,
    samplingMonitorSpecies,
    labCountryStandardGroupTopic,
    labCountryStandardGroupTopicLabTopic,
    samplingMonitorTypeLabTopic,
    samplingMonitorProduct,
    labMonitorProductGroup,
    labMonitorProductGroupRel,
    labMonitorProductGroupTopic,
}
